import {
  faBug,
  faBuildings,
  faCar,
  faCircleQuestion,
  faCreditCard,
  faReceipt,
  faSoup,
  faStar,
  faUtensils,
} from '@fortawesome/pro-regular-svg-icons';

type IconDefinition = typeof faUtensils;

// Intercom's collection `icon` is a CDN SVG URL, not an icon name, so these are mapped locally.
const COLLECTION_ICONS: Record<string, IconDefinition> = {
  'Getting started': faUtensils,
  'Order management': faReceipt,
  Troubleshooting: faBug,
  Delivery: faCar,
  Payments: faCreditCard,
  Rewards: faStar,
  'ezCater Enterprise': faBuildings,
  'Meal Program': faSoup,
};

export const collectionIcon = (name: string): IconDefinition =>
  COLLECTION_ICONS[name] ?? faCircleQuestion;
